import { useState as m } from "react";
const l = (c, e, t) => Math.min(Math.max(c, e), t);
function h(c, e, t, s, u) {
  const [n, a] = m(l(c, e, t)), r = (i) => {
    const o = n + i;
    a(o), u?.(o);
  };
  return {
    value: n,
    increment: () => r(1),
    decrement: () => r(-1),
    incrementIsDisabled: n >= t || s,
    decrementIsDisabled: n <= e || s
  };
}
export {
  h as useCounter
};
